//@flow

import styled from "styled-components"
import TitleContainer from "../Shared/TitleContainer"
import TitleContent from "../Shared/TitleContent"
import Title from "../Shared/Title"

export const Intro = TitleContainer.extend`
  width: 680px;
  top: 144px;
  right: 130px;
  position: absolute;
  z-index: 2;
`

export const IntroTitle = Title.extend`
  font-size: 72px;
  line-height: 0.875em;
  margin: 0.25rem 0 1.75rem 0;
`.withComponent("h1")

export const IntroDescription = TitleContent.extend`
  font-size: 30px;
  color: #d6d6d6;
  margin-top: 0;
  text-shadow: 0 0 28px rgba(0, 0, 0, 0.6);
  font-weight: 300;
`.withComponent("p")

export const NoBurn = Intro.extend`
  width: 1160px;
  top: 148px;
  left: 428px;
  right: auto;
`
export const NoBurnIcon = styled.img`
  flex-basis: 300px;
  width: 300px;
  height: 324px;
  flex-shrink: 0;
  flex-grow: 0;
  display: block;
  margin-right: 2rem;
`

export const NoBurnTitle = IntroTitle.extend`
  color: #2d2d2d;
  font-size: 64px;
  text-shadow: 0 0 28px rgba(255, 255, 255, 0.6);
`

export const NoBurnDescription = IntroDescription.extend`
  color: #575757;
  font-size: 36px;
  text-shadow: 0 0 28px rgba(255, 255, 255, 0.6);
`

export const TimelapseVideo = styled.video`
  height: 900px;
  width: 1600px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -450px 0 0 -800px;
  z-index: 0;
  pointer-events: none;
  transform: scale(1.4, 1.4) translate(30px, -100px);
`

export const TimelapseImageSet = styled.div`
  height: 900px;
  width: 1600px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -450px 0 0 -800px;
  z-index: 0;
  opacity: ${props => (props.visible ? 1 : 0)};
  transition: opacity 0.5s ease-out;
`

export const TimelapseImage = styled.img`
  height: 900px;
  width: 1600px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: ${props => (props.visible ? 1 : 0)};
  pointer-events: none;
  transform: scale(1.4, 1.4) translate(30px, -100px);
  opacity: ${props => (props.visible ? 1 : 0.01)};
`

export const IntroSecondary = IntroDescription.extend`color: #feffff;`



// WEBPACK FOOTER //
// ./src/Kiosk/WoodburningView/UI.js